import { Ticket, Mic, Handshake, Settings, Users, UtensilsCrossed } from 'lucide-react'
import LoopPage from '../../components/LoopPage'

const stakeholders = [
  { icon: Users, label: 'Organizers', description: 'What stretched the team? Which decisions paid off? What would you do differently?' },
  { icon: Ticket, label: 'Attendees', description: 'Did the event meet expectations? What would bring you back? What would you change?' },
  { icon: Handshake, label: 'Sponsors', description: 'Where did you see ROI? What activations worked? What would increase the value next year?' },
  { icon: UtensilsCrossed, label: 'Food & beverage', description: 'Service flow, dietary coverage, peak-time pressure. The breakdowns the front-of-house knows about.' },
  { icon: Settings, label: 'Venue staff', description: 'What broke? What worked? What would you change about how the event was run?' },
  { icon: Mic, label: 'Speakers', description: 'How was your experience on stage? What support did you need? Would you return?' },
]

export default function EventLoop() {
  return (
    <LoopPage
      h1="One event. Every voice. One loop closed."
      subhead="Run parallel feedback loops across organizers, attendees, sponsors, vendors, and staff. Synthesize across all of them in a single growth retro."
      outerLoopSteps={['Plan', 'Execute', 'Retro', 'Improve']}
      gapHeadline="The post-event survey isn't enough"
      gapBody="Post-event surveys ask attendees alone. The organizer, sponsors, food vendors, and staff hold the perspectives that matter most for next year. Generic NPS-style attendee feedback misses what actually went wrong (or right). PrismScope closes the gap across every stakeholder, in parallel."
      stakeholders={stakeholders}
      sampleRetro={{
        wentWell: 'Registration UX. Keynote sequencing. Breakout-format experimentation. First-time attendee onboarding.',
        couldHaveBeenBetter: 'Vendor coordination on day 2. Sponsor visibility in the foyer. AV transitions between sessions.',
        whatsNext: 'Activate sponsors in lounge spaces, not just booths. Add a 15-minute buffer between sessions. Pre-brief vendors on the run-of-show.',
      }}
      audienceCallouts={[
        { title: 'For conference organizers', body: 'Capture the full picture from first registration to post-event sentiment. Compare what attendees said with what sponsors paid for.' },
        { title: 'For corporate offsites and summits', body: 'Run organizer, attendee, and staff loops in parallel. Get a clean retro your CEO can read in five minutes.' },
      ]}
      trackingPrefix="event-loop"
      seoTitle="Event Feedback — Every Stakeholder, One Loop"
      seoDescription="Multi-stakeholder event feedback across organizers, attendees, sponsors, vendors, and staff. Conversational surveys that close the loop in hours, not weeks."
      seoPath="/feedback-loops/event"
    />
  )
}
